var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKrIcon = function SvgKrIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kr-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kr-icon_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14v14H0V0Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#kr-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 10.808c0 .449-.164.879-.456 1.196a1.495 1.495 0 0 1-1.1.496H1.556c-.413 0-.809-.178-1.1-.496A1.77 1.77 0 0 1 0 10.808V3.192c0-.449.164-.879.456-1.196a1.495 1.495 0 0 1 1.1-.496h10.888c.413 0 .809.178 1.1.496.292.317.456.747.456 1.196v7.616Z",
    fill: "#EEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.338 5.096a2.332 2.332 0 0 0-3.249.573A1.166 1.166 0 1 0 7 7.006a1.166 1.166 0 0 1 1.912 1.338 2.332 2.332 0 0 0-.573-3.248Z",
    fill: "#C60C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.622 6.72a1.167 1.167 0 0 0-1.624.286 1.166 1.166 0 1 1-1.91-1.337A2.332 2.332 0 1 0 8.91 8.344a1.166 1.166 0 0 0-.287-1.624Z",
    fill: "#003478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.213 9.057-.75.894.297.25.75-.894-.297-.25Zm.25-.298.297.25.749-.892-.298-.25-.749.892Zm.345.798-.75.893.298.25.75-.892-.298-.25Zm.25-.298.297.25.75-.893-.298-.25-.75.893Zm.345.798-.75.893.298.25.75-.893-.298-.25Zm.25-.298.298.25.75-.893-.298-.25-.75.893Zm.298-5.756-.298.25.75.894.298-.25-.75-.894Zm-.25-.297-.75-.894-.296.25.749.894.297-.25Zm.106 1.94-1.749-2.084.298-.25 1.75 2.085-.299.25Zm-1.297-.941-.75-.893-.297.25.75.893.297-.25Zm.25.298-.298.25.75.893.298-.25-.75-.893Zm-6.52 5.198L2.491 8.116l.297-.25 1.75 2.085-.298.25Zm-1.298-.942-.75-.893-.297.25.75.893.297-.25Zm.25.298-.297.25.75.893.297-.25-.75-.893ZM3.05 11.2l-1.75-2.084.298-.25 1.75 2.084-.298.25Zm.297-8.138L1.597 5.147l-.298-.25 1.75-2.085.297.25Zm.596.5-1.75 2.084-.297-.25 1.749-2.084.298.25Zm.595.5L2.788 6.146l-.298-.25 1.75-2.084.297.25Z",
    fill: "#292F33"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kr-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgKrIcon;